import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { OrganizationsService, UserService } from "@appcore/service";
import { first } from "rxjs/operators";
import * as shajs from "sha.js";
import { Organization } from "@data/organization";
import { ServerErrorResponse, ServiceResponse } from "@data/response";

@Component({
	templateUrl: "register.component.html",
	providers: [OrganizationsService]
})
export class RegisterComponent implements OnInit {
	registerForm: FormGroup;
	loading = false;
	submitted = false;
	_organizations = [];
	organizationsListModel: string[] = [];

	constructor(
		private formBuilder: FormBuilder,
		private router: Router,
		private userService: UserService,
		private organizationsService: OrganizationsService
	) {
		// redirect to home if already logged in
		/*
			if (this.authenticationService.currentUserValue) {
				this.router.navigate(['/']);
			}
			*/
	}

	ngOnInit(): void {
		this.registerForm = this.formBuilder.group({
			organization: ["", Validators.required],
			password: ["", [Validators.required, Validators.minLength(6)]]
		});
		this.organizationsService.getOrganizations(true).subscribe(response => {
			this._organizations = (<Organization[]>response.payload).map(function (org: {
				orgName: string;
				orgID: any;
			}) {
				return {
					label: org.orgName,
					value: org.orgID
				};
			});

			this._organizations.unshift({
				label: "-- Choose Your Organization --",
				value: ""
			});
		});
	}

	// convenience getter for easy access to form fields
	get f() {
		return this.registerForm.controls;
	}

	onSubmit() {
		this.submitted = true;

		// stop here if form is invalid
		if (this.registerForm.invalid) {
			return;
		}

		this.loading = true;

		const fPWVal = this.f.password.value;
		const hashword = shajs("sha256").update(fPWVal).digest("hex");

		this.userService
			.register(this.f.organization.value, hashword)
			.pipe(first())
			.subscribe(
				() => {
					console.log("organization registered");
					// this.alertService.success('Registration successful', true);
					this.router.navigate(["/login"]);
				},
				() => {
					console.log("organization registration error");
					// this.alertService.error(error);
					this.loading = false;
				}
			);
	}
}
